export const QUESTIONS_TYPE = [
  { value: "multi", label: "Question choix multiple" },
  { value: "simple", label: "Question simple" },
  { value: "multiInfo", label: "Question choix multiple - Informative" },
  { value: "simpleInfo", label: "Question simple - Informative" },
  { value: "photo", label: "Prise de photo" },
  { value: "video", label: "Prise de video" },
  // { value: 'libre', label: 'Libre' },
]

// GESTION DES SOUS CATEGORY

export const QUESTIONS_CATEGORY = [
  { value: 1, label: "Hébergement", ref: "" },
  { value: 2, label: "Alimentation", ref: "" },
  { value: 3, label: "Santé", ref: "" },
  { value: 4, label: "Comportement", ref: "" },
]

export const QUESTIONS_SUBCATEGORY_1 = [
  { value: null, label: "Pas de sous categorie" },
  { value: 101, label: "Aménagements de l'enclos extérieur" },
  { value: 102, label: "Aménagements de l'enclos intérieur" },
  { value: 103, label: "Surfaces" },
  { value: 111, label: "Confort thermique" },
  { value: 112, label: "Confort visuel" },
  { value: 113, label: "Confort acoustique" },
  { value: 114, label: "Propreté de l'environnement" },
  { value: 115, label: "Confort ambiant" },
  { value: 121, label: "Sécurité et prévention" },
  { value: 131, label: "Possibilités comportementales - extérieur" },
  { value: 132, label: "Possibilités comportementales - interieur" },
]

export const QUESTIONS_SUBCATEGORY_2 = [
  { value: null, label: "Pas de sous categorie" },
  { value: 201, label: "Hygiène et préparation" },
  { value: 202, label: "Présentation de la nourriture" },
  { value: 203, label: "Ration alimentaire" },
  // { value: 204, label: 'Régime individuel' },
]

export const QUESTIONS_SUBCATEGORY_3 = [
  { value: null, label: "Pas de sous categorie" },
  { value: 301, label: "Etat physique" },
  { value: 302, label: "Soins curatifs" },
  { value: 303, label: "Suivi préventif" },
]

export const QUESTIONS_SUBCATEGORY_4 = [
  { value: null, label: "Pas de sous categorie" },
  { value: 401, label: "Choix et contrôle sur l'environnement social et physique" },
  { value: 402, label: "Comportements exprimés par l'animal" },
  { value: 403, label: "Enrichissements et stimulations" },
  { value: 404, label: "Suivi comportemental" },
  { value: 405, label: "Training" },
]

export const QUESTION_POINTS = [
  { value: null, label: "Ne sais pas", nullReason: "NC" },
  { value: null, label: "Non applicable", nullReason: "NA" },
  { value: 0, label: "0" },
  { value: 0.5, label: "0.5" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: -0.5, label: "-0.5" },
  { value: -1, label: "-1" },
  { value: -1.5, label: "-1.5" },
  { value: -2, label: "-2" },
  { value: -2.5, label: "-2.5" },
  { value: -3, label: "-3" },
  { value: -3.5, label: "-3.5" },
  { value: -4, label: "-4" },
  { value: -4.5, label: "-4.5" },
  { value: -5, label: "-5" },
]

export const QUESTION_POINTS_INFO = [{ value: null, label: "Informative", nullReason: "info" }]

export const ALERT_OPTIONS = [
  {
    value: null,
    label: "Pas d'alerte",
  },
  {
    value: "welfare",
    label: "Enjeux bien être",
  },

  {
    value: "legal",
    label: "Anomalie réglementaire ",
  },

  {
    value: "danger1",
    label: "Danger soigneur",
  },

  {
    value: "danger",
    label: "Situation risquée",
  },
]
